'use strict';

/**
 * Model for the imports
 *
 * @category   Model
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoModel = require('base/Colido.Model');
var MatchesCollection = require('../collections/matches');

var ImportModel = ColidoModel.extend({
    api: '/imports',

    urlRoot: false, //needed to get proper api endpoint for models which are part of subcollection (catalog.objects...) with dynamic api urls

    defaults: {
        state: 'upload',
    },

    validationEnabled: true,

    constructor: function(attributes, options) {
        this.matches = new MatchesCollection();

        ColidoModel.apply(this, arguments);

        this.on('change:state', this.onStateChange.bind(this));
    },

    parse: function (data) {
        var importFields = App.CollectionModule.catalogs.getActiveCatalog().getImportFields();

        // Populate matches
        var matches = _.map(data.columnsOrder, function(id, position) {
            // Add display name to match when available
            var displayName;
            if (data.columns[id]) {
                var importField = _.findWhere(importFields, {
                    fieldName: data.columns[id].fieldname,
                });

                if (importField) {
                    displayName = importField.name;

                    // Trigger selection
                    // App.radio('base').trigger(
                    //     'collection-fields:selection-changed',
                    //     importField.fieldName,
                    //     null,
                    //     true
                    // );
                }
            }

            // Add examples to match
            var examples = data.preview.map(function (previewEntry) {
                return previewEntry[id];
            });

            return _.extend({}, data.columns[id], {
                id: id,
                displayname: displayName,
                examples: examples,
                position: position,
            });
        });

        this.matches.reset(matches);
        this.matches.sortByFields('position.asc');
        delete data.columns;

        return data;
    },

    toJSON: function () {
        var json = ColidoModel.prototype.toJSON.apply(this, arguments);

        json.columns = _.object(this.matches.map(function (match) {
            return [
                match.id,
                {
                    fieldname: match.get('fieldname') || null,
                    dismissed: match.get('dismissed'),
                },
            ];
        }));

        return json;
    },

    url: function () {
        var url = ColidoModel.prototype.url.apply(this, arguments);

        if (this.id && this.get('secret')) {
            url += '?secret=' + this.get('secret');
        }

        return url;
    },

    validate: function (attrs, options) {
        var isValid = this.matches.reduce(function(isValid, model) {
            return (model.isValid() && isValid);
        }, true);

        if (!isValid && this.validationEnabled) {
            return 'match is not valid';
        }
    },

    /**
     * Disables the validation
     */
    disableValidation: function() {
        this.validationEnabled = false;
    },

    /**
     * Enables the validation
     */
    enableValidation: function() {
        this.validationEnabled = true;
    },

    /**
     * Returns true, if validation is enabled
     * @returns {boolean} True, if validation is enabled. Otherwise false
     */
    isValidationEnabled: function() {
        return this.validationEnabled;
    },

    onStateChange: function(model, newValue) {
        if (newValue === 'complete') {
            Messenger().post({
                type: 'success',
                message: App.t('collection::import:response:import-finished', {name: model.get('file').filename}),
                actions: {
                    show: {
                        label: App.t('collection::import:button:show-import'),
                        action: function () {
                            App.router.navigate('/catalogs/' + model.collection.catalog.id + '/imports/' + model.id, {trigger: true});
                        },
                    },
                },
                hideAfter: 0,
            });
        }
    },
});

module.exports = ImportModel;